import { v4 as uuidv4 } from "uuid";

import {
  OFFER_PLAN_TYPES,
  PLATFORM_TYPES,
  RESOLUTION_TYPES,
} from "../components/offers/offerPlan.constants";
import {
  apiToPlanForm,
  planFormToCreateApi,
} from "../components/offers/offerPlanAdapter";

import type { CreateOfferPlanToApi } from "../models/OfferPlan.types";
import type { OfferPlanType } from "../types";

const EDU_PLAN_FREQUENCY_IN_MONTHS = 12;

export function getNewEduOfferPlan(): OfferPlanType {
  return {
    isNew: true,
    uuid: uuidv4(),
    type: OFFER_PLAN_TYPES.SVOD,
    platform: PLATFORM_TYPES.EDU,
    frequency: EDU_PLAN_FREQUENCY_IN_MONTHS,
    enabled: true,
    resolution: RESOLUTION_TYPES.HD,
    require_registration: true,
  };
}

export function eduOfferPlanToApi(offerUuid: string): CreateOfferPlanToApi {
  return planFormToCreateApi(apiToPlanForm(getNewEduOfferPlan()), offerUuid);
}
